// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@-webkit-keyframes _3RMBW{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}@keyframes _3RMBW{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}.sua6B{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:8px;gap:.8rem;padding:0 1.6rem}.sua6B .DateRangePicker{width:100%}.sua6B .DateRangePicker_picker{z-index:1000}.sua6B label.form-label{margin-bottom:.4rem}", ""]);
// Exports
exports.locals = {
	"notificationsFilters": "sua6B",
	"fading": "_3RMBW"
};
module.exports = exports;
